import {IDatabaseItemRouteSource} from '@toolify/client/src/modules/databases/types/IDatabaseItemRouteSource'

interface IRouteLocationLike {
  params: Record<string, unknown>
  query: Record<string, unknown>
}

export function getDatabaseItemRouteSource({params, query}: IRouteLocationLike): IDatabaseItemRouteSource {
  const isRelated = typeof query.fromDatabaseId === 'string'
  const databaseId = isRelated ? query.fromDatabaseId : params.databaseId
  const viewId = isRelated ? query.fromViewId : query.viewId
  return {
    databaseId: typeof databaseId === 'string' ? databaseId : null,
    viewId: typeof viewId === 'string' ? viewId : null,
    isRelated,
  }
}
